import { postEvents } from "library/api";
import { authClient } from "library/auth";
import { useContext } from "react";
import { UserContext } from "./UserContext";

export type LoginUserParam = {
  id: string;
  password: string;
};

export const useAuthentication = () => {
  const { setProfile } = useContext(UserContext);

  const loginUser = async ({ id, password }: LoginUserParam) => {
    try {
      await authClient.login({ id, password });
      // post LOGIN_SUCCESSFUL event, this is async
      postEvents({
        data: { event: "LOGIN_SUCCESSFUL", email: id },
      });
    } catch (err) {
      postEvents({
        data: { event: "LOGIN_UNSUCCESSFUL", email: id },
      });
      throw err;
    }
  };

  const logoutUser = (options = { redirectTo: "login" }) =>
    // logout will logout user in okta
    authClient.logout(options).finally(() => {
      // remove profile when logged out.
      setProfile(null);
    });

  return { loginUser, logoutUser };
};
